import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PolicyArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="Artboard" transform="translate(-663.000000, -45.000000)">
          <g id="Policy_article" transform="translate(663.000000, 45.000000)">
            <path
              d="M0,15 C0,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 0,6.716 0,15"
              fill="#57B548"
              id="Fill-1"
            ></path>
            <path
              d="M9,22.3521 C9,22.8631 9.418,23.2801 9.928,23.2801 L20.346,23.2801 C20.856,23.2801 21.274,22.8631 21.274,22.3521 L21.274,11.0821 C21.274,10.5721 20.991,9.8471 20.645,9.4721 L18.549,7.2001 C18.203,6.8241 17.502,6.5171 16.992,6.5171 L9.928,6.5171 C9.418,6.5171 9,6.9351 9,7.4451 L9,22.3521 Z"
              fill="#ffffff"
              className={styles.white}
              id="Fill-3"
            ></path>
            <polyline
              id="Stroke-5"
              points="17.92 6.5173 17.92 10.1643 21.274 10.1543"
              stroke="#57B548"
              strokeLinejoin="round"
              strokeWidth="0.5"
            ></polyline>
            <line
              id="Stroke-7"
              stroke="#57B548"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="18.4048"
              y1="11.8187"
              y2="11.8187"
            ></line>
            <line
              id="Stroke-9"
              stroke="#57B548"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="13.6448"
              y1="15.5952"
              y2="15.5952"
            ></line>
            <line
              id="Stroke-11"
              stroke="#57B548"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="13.6448"
              y1="17.4408"
              y2="17.4408"
            ></line>
            <line
              id="Stroke-13"
              stroke="#57B548"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="18.4048"
              y1="13.701"
              y2="13.701"
            ></line>
            <g id="Group-18" transform="translate(15.189378, 14.850800)">
              <path
                d="M4.41892226,0 C4.41892226,0 2.38692226,1.863 0.0149222647,1.355 C0.0149222647,1.355 -0.493077735,7.452 4.41892226,9.654 L4.40392226,9.654 C9.31592226,7.452 8.80792226,1.355 8.80792226,1.355 C6.43692226,1.863 4.40392226,0 4.40392226,0"
                fill="#ffffff"
                className={styles.white}
                id="Fill-15"
              ></path>
              <path
                d="M4.41892226,0 C4.41892226,0 2.38692226,1.863 0.0149222647,1.355 C0.0149222647,1.355 -0.493077735,7.452 4.41892226,9.654 L4.40392226,9.654 C9.31592226,7.452 8.80792226,1.355 8.80792226,1.355 C6.43692226,1.863 4.40392226,0 4.40392226,0"
                id="Stroke-17"
                stroke="#57B548"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
              ></path>
            </g>
            <path
              d="M21.7952,19.3356 C21.7952,20.4546 20.8882,21.3616 19.7692,21.3616 C18.6492,21.3616 17.7422,20.4546 17.7422,19.3356 C17.7422,18.2166 18.6492,17.3096 19.7692,17.3096 C20.8882,17.3096 21.7952,18.2166 21.7952,19.3356"
              id="Fill-19"
              stroke="#57B548"
            ></path>
            <polyline
              id="Stroke-21"
              points="18.7519 19.4296 19.3679 20.0456 20.7549 18.6596"
              stroke="#FFFFFF"
              className={styles.whiteStroke}
              strokeWidth="0.5"
            ></polyline>
          </g>
        </g>
      </g>
    </Icon>
  )
}
